export const ABOUT_ME = "Hello! I'm Tanveer Ahmed Khan, a dedicated Full Stack Developer with a passion for creating seamless and innovative digital experiences. With 2+ years of experience in both front-end and back-end development, I bring a comprehensive understanding of the entire web development lifecycle, from designing intuitive user interfaces to implementing robust server-side logic."
export const SKILLS = "I specialize in full stack development with a strong focus on Node.js and React. On the frontend, I leverage React for building dynamic, responsive user interfaces with state management tools like Redux and Context API. For the backend, I utilize Node.js with frameworks like Express.js to create robust APIs and server-side logic. My experience includes managing databases such as MSSQL, implementing authentication and authorization, and deploying applications using Docker and AWS. I am proficient in version control with Git and CI/CD practices to ensure smooth and efficient development workflows."
export const TERMINAL_COMMANDS = `
Commands: 1: about - Show info, 
2: help - Show this help message, 
3: contact - Show contact information, 
4: skills - Show skills information, 
5: clear - for clearing screen.
6: exit - for closing terminal.
Commonds for navigating through website using 'open' keyword i.e open home;
1: home
2: projects
3: contact
4: about
5: resume
'Get' Commands
1: Get resume
`;

export const ROUTES_PREFIX = '/portfolio';